export enum Roles {
	'MANAGER' = 1,
	'ADMIN' = 2,
	'SUPERADMIN' = 15
}